import React from 'react';
import Cookies from 'js-cookie';
import { TruthsortingStore } from './TruthsortingStore';
import { PuzzleNames } from '../../../utils/types';
import { DOMAIN } from '../shared/utils';
import InstructionsDialog from '../../InstructionsDialog';
import { isMobile } from 'react-device-detect';

const closeInstructions = () => {
  TruthsortingStore.update(s => {
    s.instructionsAreOpen = false;
    s.isSoftPaused = false;
  });

  Cookies.set(`${PuzzleNames.Truthsorting}InstructionsDismissed`, 'true', {
    domain: DOMAIN,
    expires: 365,
  });
};

const Instructions = () => {
  const isOpen = TruthsortingStore.useState(s => s.instructionsAreOpen);

  return (
    <InstructionsDialog isOpen={isOpen} onClose={closeInstructions} className="twoColumnInstructions">
      <h1 className="instructionsTitle">How to Play Truthsorting</h1>
      <div className="instructionsBody">
        <p>
          Truth slots are white. Lie slots are black.
        </p>
        <br/>
        <p>
          Drag to reorder the statements so that truth slots contain truths and lie slots contain lies.
        </p>
        <br/>
        <p>
          Whether statements are truths or lies depends entirely on the order they're in.
        </p>
        <br/>
        <p>
          A checkmark is shown on any statement whose current truthfulness matches its slot, but that doesn't necessarily mean it's in the right place. The puzzle is solved when <span className="boldText">all</span> statements have checkmarks.
        </p>
        <br/>
        <p>
          There is only one solution. Good luck.
        </p>
      </div>
    </InstructionsDialog>
  );
};

export default Instructions;